import React, {useEffect, useState} from 'react';
import { MultiSelect } from 'react-multi-select-component';
import styled from 'styled-components/macro';

const StyledMultiSelectDropdown = styled(MultiSelect)`
    width: 220px;
    --rmsc-h: 38px;
    --rmsc-selected: rgb(223, 230, 237);
    --rmsc-hover: rgb(223, 230, 237);
    --rmsc-border: hsl(210, 5%, 90%);
    --rmsc-radius: 5px;
    --rmsc-gray: hsl(210, 5%, 15%);
    color: hsl(210, 5%, 15%);
    padding: 0px;
    margin: 0px;
    text-align: left;
    font-size: 16px;
    text-indent: 0;
    font-family: inherit;
`;


const CheckboxWrapper = styled.div`
height: 17px;
display: flex;
align-items: center;
font-family: "Arimo","Open Sans","HelveticaNeue","Helvetica Neue","Arial","sans-serif";
`

const StyledCheckbox = styled.input`
-webkit-appearance: none;
-moz-appearance: none;
appearance: none;
margin-left: -5px;

&:checked:before {
content: '•';
color: rgb(47, 47, 48);
font-size: 25px;
padding-right: 2px;
}
&:before {
content: '•';
color: transparent;
font-size: 25px;
padding-right: 2px;
}
`

function GroupsDropdown (props) {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if(props.options) {
            setOptions([{label: 'All Groups', value: 'all_groups'}, ...props.options])
        }
    },[props.options])

      const customItemRenderer = ({option, checked, onClick}) => {
        return (
          <CheckboxWrapper>
            <StyledCheckbox {...props} type='checkbox' checked={checked} onChange={onClick}/>
            {option.label}
          </CheckboxWrapper>
        )
      }

    const customValueRenderer = (selected, _options) => {
        if (selected.length === 1) {
            return <p>{selected[0].label}</p>
        } else if(selected.length === _options.length - 1) {
            return <p>All Groups</p>
        } else {
            return <p>{selected.length} Groups</p>
        }
    };
    const handleChange = (e) => {
        if(e.length === 0) return; //Prevents user from deselecting all groups
        if(e[e.length - 1].value === 'all_groups' || e.length === options.length - 1) {
            props.onChange([{label: 'All Groups', value: 'all_groups'}])
        } else {
            let newList = e.filter((g) => g.value !== 'all_groups')
            props.onChange(newList);
        }
    }

    return (
            <StyledMultiSelectDropdown
                {...props}
                overrideStrings={{
                    "allItemsAreSelected": `All Groups`,
                    "selectSomeItems": `No Groups`,
                    "search": `Search`,
                    "selectAll": `All Groups`,
                    "noOptions": `No Groups`,
                }}
                valueRenderer={customValueRenderer}
                ItemRenderer={customItemRenderer}
                multiSelectionText={'Selected'}
                options={options}
                value={props.value.length === options.length - 1 ? [{label: 'All Groups', value: 'all_groups'}] : props.value}
                onChange={(e) => handleChange(e)}
                hasSelectAll={false}
            />
    )
}

export default GroupsDropdown;